import { capitalize } from 'utilities';

export const formatString = (value: string) => {
  if (!value) return '';

  return capitalize(value.toLowerCase()) + ': ';
};